<template lang="pug">
  .pagination
    ul.w-full.flex.select-none(:class="`justify-${horizontalPosition}`")
    
      li.mx-30.min-w-8.w-24.h-24.flex.items-center.justify-center.prev.text-14.px-5.rounded-50.text-grey-4d(
        @click="changePage('prev')"
        class=" active:text-grey-4c  hover:text-grey-4c "
        :class="[{'cursor-pointer': current > range , 'hidden':hiddenClass('prev')}]")
        //- |&lt;
        iCon.w-24.h-24.rotate-180.transform(:iconClass="'ico_Next'"  type="svg" :class="{'text-black': current > this.range}")
      li.min-w-24.h-24.mx-6.min-w-8.flex.items-center.justify-center.page.text-14.cursor-pointer.px-5.rounded-50.leading-2(
        v-for="number in pageRange" 
        :class="setActiveClass(number)" class="  hover:text-grey-4c  active:text-grey-4c" @click="changePage(number)")  {{number}}
      li.min-w-8.flex.items-center.justify-center.page.text-14.px-5.text-grey-b4.cursor-pointer(
        v-if="current + totalPage % range <=  totalPage   && totalPage > range" @click="changePage('next')") ... 
      
      li.mx-30.min-w-8.w-24.h-24.flex.items-center.justify-center.prev.text-14.text-grey-4d.px-5.rounded-50(
        @click="changePage('next')" 
        class=" active:text-grey-4c  hover:text-grey-4c "
        :class="{'cursor-pointer': current < totalPage - range +1 , 'hidden':hiddenClass('next')}")
        //- |&gt;
        iCon.w-24.h-24(:iconClass="'ico_Next'"  type="svg" :class="{'text-black': current + totalPage % range <=  totalPage   && totalPage > range}")
</template>

<script>
export default {
  name: "Pagination",
  props: {
    position: {
      type: String,
      required: true
    },
    totalPage: {
      type: [Number, String],
      required: true
    },
    nowPage: {
      type: [Number, String],
      required: true
    },
    range: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      // range: 5,
      rightDisable: false
    };
  },
  mounted() {},
  computed: {
    current: {
      get() {
        return parseInt(this.nowPage);
      },
      set(val) {
        console.log(val, "val");
        this.$emit("changePage", val);
      }
    },
    horizontalPosition() {
      return this.position === "" ? "end" : this.position;
    },
    pageRange() {
      let left;
      let rightBlock;
      if (this.current % 5 == 0) {
        left = this.range * (Math.floor(this.current / this.range) - 1) + 1;
        rightBlock = left + 4;
      } else {
        left = this.range * Math.floor(this.current / this.range) + 1;
        rightBlock = left + 4;
      }
      // console.log(rightBlock,left,this.totalPage,  this.totalPage,'??')
      const arr = [];
      if (this.totalPage > this.range) {
        for (let i = left; i <= rightBlock; i++) {
          if (i >= 1 && i <= this.totalPage) {
            arr.push(i);
          }
        }
      } else {
        for (let i = 0; i < this.totalPage; i++) {
          arr.push(i + 1);
        }
      }

      return arr;
    }
  },
  methods: {
    setActiveClass(number) {
      return {
        ["text-black"]: number === this.current,
        ["text-grey-b4"]: number !== this.current,
        ["hover:text-grey-80"]: number !== this.current
      };
    },
    hiddenClass(flag) {
      let result = false;
      // console.log(this.current, this.totalPage, this.range)
      if (flag === "prev") {
        if (this.current == 1 || this.totalPage <= this.range || this.current <= this.range) result = true;
      }
      else if (flag === "next") {
        if (this.totalPage % 5 != 0) {
          if (this.current % 5 != 0) {
            if (parseInt(this.totalPage / this.range) - parseInt(this.current / this.range) < 1) {
              result = true;
            } else {
              if (this.totalPage == this.range) {
                result = true;
              }
            }
          }
        } else {
          if (this.current % 5 != 0) {
            if (parseInt(this.totalPage / this.range) - parseInt(this.current / this.range) <= 1) {
              result = true;
            }
          } else {
            if (parseInt(this.totalPage / this.range) - parseInt(this.current / this.range) == 0) {
              result = true;
            }
          }
        }
      }
      return result
    },
    changePage(current) {
      let jump;
      let startNum;
      if (current === "next") {
        // console.log(this.current,parseInt(this.totalPage/ this.range), parseInt(this.current/ this.range) )

        if (this.totalPage % 5 != 0) {
          if (this.current % 5 != 0) {
            if (parseInt(this.totalPage / this.range) - parseInt(this.current / this.range) < 1) {
              return;
            } else {
              if (this.totalPage == this.range) {
                return;
              }
            }
          }
        } else {
          if (this.current % 5 != 0) {
            if (parseInt(this.totalPage / this.range) - parseInt(this.current / this.range) <= 1) {
              return;
            }
          } else {
            if (parseInt(this.totalPage / this.range) - parseInt(this.current / this.range) == 0) {
              return;
            }
          }
        }
        if (this.current % 5 == 0) {
          jump = this.current += this.range;
          startNum = Math.floor(jump / this.range);
          this.current = (startNum - 1) * this.range + 1;
        } else {
          jump = this.current += this.range;
          startNum = Math.floor(jump / this.range);
          this.current = startNum * this.range + 1;
        }
      } else if (current === "prev") {
        if (this.current == 1) return;
        if (this.current - this.range <= 0) {
          this.current = 1;
        } else {
          jump = this.current - this.range;
          startNum = Math.floor(jump / this.range);
          this.current = startNum * this.range + 1;
        }
      } else {
        if (this.current == current) return;
        this.current = current;
      }
      window.scrollTo({
        top: 0
      });
    }
  }
};
</script>
